import { useTranslation } from 'react-i18next';
import { I18N_SUPPORTED_LANGUAGES } from '../constants/languages';

/** UI language (not the menu preview language). Persistence, <html lang> and dayjs follow in i18n.ts. */
export const useLanguage = () => {
    const { i18n } = useTranslation();
    const code = i18n.resolvedLanguage ?? i18n.language;
    return {
        code,
        languages: I18N_SUPPORTED_LANGUAGES,
        current: I18N_SUPPORTED_LANGUAGES.find((l) => l.code === code) ?? I18N_SUPPORTED_LANGUAGES[0],
        change: (next: string) => void i18n.changeLanguage(next),
    };
};
